/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,CardTitle,CardFooter,
  Row,
  Col
} from "reactstrap";
// core components
import { connect } from "react-redux";
import GeneralHeader from "components/Headers/GeneralHeader";
import axios from 'axios';
import {addGrades,addSelectedSubject} from 'actions/index';
import Loader from 'react-loader-spinner';
import AvailableTable from "./tables/AvailableTable";


const mapStateToProps = state => ({
  grades: state.grades,subject_selected:state.subject_selected
});

function mapDispatchToProps(dispatch) {
  return {
    addGrades: grades => dispatch(addGrades(grades)),addSelectedSubject: subject=>dispatch(addSelectedSubject(subject))
  };
}


class Available extends React.Component {
  constructor(props) {
    super(props);
    this.state = {       
     subjects:[],
     grades:[],
     subjectClicked:false,
     grade_name:'',
     available_scripts:[],
     scriptsLoaded:false,
     subjectsLoaded:false,
     generateCards:true,
     gradesLoading:true,
     subjectsLoading:false,
     subject_selected:'',
     goBackToSubjects:false,
    }; 
    this.generateCards = this.generateCards.bind(this);
    this.getGradeSubjects = this.getGradeSubjects.bind(this);
    this.generateSubjectCards = this.generateSubjectCards.bind(this);
    this.getAvailableScripts = this.getAvailableScripts.bind(this);
    this.getGrades = this.getGrades.bind(this);
    this.goToGrades = this.goToGrades.bind(this);
    this.subjectGoBack = this.subjectGoBack.bind(this);
  }

  componentDidMount(){
    // //console.log('props state',this.state.subject_selected);
    this.getGrades();
    this.setState({full_name:localStorage.getItem('full_name')});    
  }  

  goToGrades(){
    this.setState({subjectsLoaded:false,generateCards:true,subjectClicked:false,goBackToSubjects:false,scriptsLoaded:false});
  }

  subjectGoBack(){
    this.setState({subjectsLoaded:true,generateCards:false,subjectClicked:true,goBackToSubjects:true,scriptsLoaded:false});
  }

  getGrades() {
    // //console.log('getting grades');
    axios.get('https://admin.thinkdigitalacademy.org/api/marker-portal-get-grades').then(res=>{
          console.log('grades',res.data);
         this.props.addGrades(res.data.grades);   
         this.setState({grades:res.data.grades,goBackToSubjects:false,gradesLoading:false});
        //  //console.log('props',this.props.grades);   
         
      }).catch(error =>{
          // //console.log('error',error);
      });    
  }
  

  getGradeSubjects(id,e){
   console.log('getting subjects for',id);
    axios.get('https://admin.thinkdigitalacademy.org/api/marker-portal-get-grade-subjects/'+id).then(res=>{
          console.log('subjects',res.data);   
         this.setState({subjectsLoading:false,subjects:res.data.subjects,subjectClicked:true,grade_name:res.data.grade_name,generateCards:false,goBackToSubjects:true});
      }).catch(error =>{
          // //console.log('error',error);
      }); 
  }

  generateCards() {
    return this.state.grades.map((prop, key) => {
     
      return (
        <Col lg={4} key={key}>
        <Card  className="card-stats mb-4 mb-xl-0" style={{ marginTop: "2em" }}>
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                           {prop.grade_name}
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                           {prop.uploads}
                          </span>
                        </div>
                        {   
                          prop.grade_name.includes('Grade')&&<Col className="col-auto">
                          <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                            <i className="ni ni-bullet-list-67" />
                          </div>
                        </Col>
                        }
                        {   
                          prop.grade_name.includes('Graad')&&<Col className="col-auto">
                          <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                            <i className="ni ni-bullet-list-67" />
                          </div>
                        </Col>
                        }
                        {   
                          prop.grade_name.includes('IGCSE')&&<Col className="col-auto">
                          <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                            <i className="ni ni-bullet-list-67" />
                          </div>
                        </Col>
                        }
                        {   
                          prop.grade_name.includes('AS Levels')&&<Col className="col-auto">
                          <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                            <i className="ni ni-bullet-list-67" />
                          </div>
                        </Col>
                        }
                      </Row>
                    </CardBody>
                    <CardFooter>
                    <Button onClick={(e) => this.getGradeSubjects(prop.id, e)} outline color="info" outline type="button">
                      View
                    </Button>
                    </CardFooter>
                  </Card>
        </Col>
      );
    });
  };

  getAvailableScripts(id,e){
    console.log('getting available scripts',id);
    this.setState({scriptsLoaded:true,subjectClicked:false,subject_selected:id}); 
    this.props.addSelectedSubject(id);
  }

  generateSubjectCards() {
    return this.state.subjects.map((prop, key) => {
     
      return (
        <Col lg={4} key={key}>
        <Card  className="card-stats mb-4 mb-xl-0" style={{ marginTop: "2em" }}>
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                           {prop.name}
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                           {prop.uploads}
                          </span>
                        </div>
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                            <img src={`https://think-digital-production.s3.eu-west-1.amazonaws.com/`+prop.picture} width={60} />
                          </div>
                      </Row>
                    </CardBody>
                    <CardFooter>
                    <Button onClick={(e) => this.getAvailableScripts(prop.id, e)} outline color="info" outline type="button">
                      View
                    </Button>
                    </CardFooter>
                  </Card>
        </Col>
      );
    });
  };
  render() {
    return (
      <>
       <GeneralHeader/>
       <Container className="mt--7" fluid>
          <Row>
            
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row>
                    <Col xs={2}>
                      <>
                   {this.state.subjectClicked && !this.state.scriptsLoaded && <Button size="sm"  color="success" type="button" onClick={this.goToGrades}>
                    Back
                  </Button>
                  } 
                  {this.state.goBackToSubjects && !this.state.subjectClicked && <Button size="sm"  color="success" type="button" onClick={this.subjectGoBack}>
                    Back
                  </Button>
                  } 
</>
                    </Col>
                <Col xs="9">  
                <div className="text-center">              
                  {
                    this.state.subjectClicked && <h3 className="mb-0">Select Subject</h3>
                  } 
                  </div>                   
                    </Col>
                    <Col xs="1">
                      {
                        this.state.subjectClicked== true? <span className='badge badge-info'>{this.state.grade_name}</span>:''
                      }
                      
                    </Col></Row>
                </CardHeader>
                <CardBody>
                  {
                    this.state.gradesLoading==true?<Loader type="Puff" color="#00BFFF"
                    height={100}
                    width={100}
                    timeout={3000}
                    //3 secs
                />:<>{
                  this.state.generateCards==true&&<Row>
                   {this.generateCards()}
                    </Row>
                }
                </>
                  }
                  {
                    this.state.subjectsLoading==true?<Loader type="Puff" color="#00BFFF"
                    height={100}
                    width={100}
                    timeout={3000}
                    //3 secs
                />:<>
                {
                    this.state.subjectClicked==true&& <Row>{this.generateSubjectCards()}</Row>
                  }
                </>
                  }                  
                  
                    {
                    this.state.scriptsLoaded&& <AvailableTable selected_subject={this.state.selectedSubject}/>
                  }            
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(Available);
